"use strict";

class Profile {
    handleDeleteAccount(form) {
        form.find("button").on("click", function (e) {
            e.preventDefault();

            if (confirm("Are you sure you want to delete your account?")) {
                form.trigger("submit");
            }

            return false;
        });
    }
}

export default Profile;
